import { noTags } from './noTags';

export default [{'name': 'noTags', 'action': noTags}];
